import * as firebase from 'firebase';

const firebaseConfig = {
  apiKey: "AIzaSyDoChVkSnXcuLfpvfnMcyQSiLZY6UzFANU",
  authDomain: "mario-37239.firebaseapp.com",
  databaseURL: "https://mario-37239.firebaseio.com",
  projectId: "mario-37239",
  storageBucket: "images.bupples.com",
  messagingSenderId: "733488586769",
  appId: "1:733488586769:web:ad808504c50fa0bcfc51b0",
  measurementId: "G-3BB89FR40M"
};
firebase.initializeApp(firebaseConfig);

export default firebase;